// คำแปลภาษาอังกฤษของข้อความที่เรียกด้วย t("ข้อความภาษาไทย")
// key คือข้อความภาษาไทยตามที่เขียนในโค้ด ฝั่งภาษาไทยไม่ต้องมีไฟล์คู่ เพราะ i18next คืนค่า key เมื่อไม่พบคำแปล
import shared from "./shared.json";
import edpex from "./edpex.json";
import courseOnline from "./course-online.json";
import personnel from "./personnel.json";
import elibrary from "./elibrary.json";
import advisor from "./advisor.json";
import cmsWebsite from "./cms-website.json";
import booking from "./booking.json";
import thesisMeeting from "./thesis-meeting.json";
import leaveRequest from "./leave-request.json";
// โหลดท้ายสุด: เลือกคำแปลมาตรฐานเมื่อหลายโมดูลแปล key เดียวกันต่างกัน และคำแปลตามบริบท
// (เช่น t("อนุมัติ", { context: "action" }) → "อนุมัติ_action" สำหรับปุ่ม, StatusCustom ใช้ context "status")
import overrides from "./overrides.json";

export const ThaiTextEn = {
  ...shared,
  ...edpex,
  ...courseOnline,
  ...personnel,
  ...elibrary,
  ...advisor,
  ...cmsWebsite,
  ...booking,
  ...thesisMeeting,
  ...leaveRequest,
  ...overrides
};
